import type { CoopRelationshipDTO } from '@bb/domain/dist/types';
import axios from 'axios';

const getCoopRelationshipsForMlsStaff = async (userId: string) => {
  const { data } = await axios.get<CoopRelationshipDTO[]>(
    `supra/mlsstaff/coop/relationships/list/${userId}`,
  );

  return data;
};

export default getCoopRelationshipsForMlsStaff;
